import React from "react";
import Link from "next/link";
import { C500 } from "@/assets/Icons";
import classes from "./Error.module.scss";

function UnknownError() {
  return (
    <div className={classes.section}>
      <div className={classes.wrapper}>
        <h2 className={classes.heading}>Something went wrong!</h2>
        <div>
          <C500 />
        </div>
        <p className={classes.text}>
          Sorry we’re unable to find the page you’re looking for.
        </p>
        <Link href="/" title="Homepage" className={classes.button}>
          Homepage
        </Link>
      </div>
    </div>
  );
}

export default UnknownError;
